import { axios } from 'lib'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { PaginatedParams, PaginatedResponse } from 'services/api/types'
import { OrderPriceListProducts } from 'modules/orders/types'

const loadOrderTrackingTitles = (
  data: PaginatedParams
): PaginatedResponse<OrderPriceListProducts> => {
  const { page = 1, limit = 100 } = data
  return axios.get(`/orders/trackings/titles`, {
    params: {
      page,
      limit,
      ...data
    }
  })
}

export function useLoadOrderTrackingTitles(query: PaginatedParams) {
  return useQuery(
    ['orderTrackingTitles', query],
    () => loadOrderTrackingTitles(query),
    {
      onError: () =>
        toast.error('Não foi possível carregar os títulos!', {
          toastId: 'orderTrackingTitles'
        })
    }
  )
}
